package io.horion.cv.di

val appModule = listOf(
    repositoryModule,
    useCaseModule,
    viewModelModules
)